export const getSafeIndex = <T>(arr: T[] = [], proposedIndex = 0) => {
  if (!arr.length) {
    return undefined;
  } else if (proposedIndex < 0 || proposedIndex >= arr.length) {
    return 0;
  } else {
    return proposedIndex;
  }
};
